import React, { Component } from 'react'
import { connect } from 'react-redux'
import withRouter from 'react-router/withRouter'
import Title from '../../../../components/typography/title.component'
import InnerPageContainer from '../../../../components/layout/private/inner-page-container.component'
import { FALE_CONOSCO_EMAIL } from '../../../../constants/fale-conosco.constants'
import Button from '../../../../components/buttons/buttons.component'

class ProcessErrorPage extends Component {
	constructor(props) {
		super(props)
		this.state = {
			navigatedByButton: false
		}
	}

	componentWillUnmount() {
		if (this.state.navigatedByButton) return
		this.gotToBuyPoints()
	}

	gotToBuyPoints = () => {
		const { history } = this.props
		this.setState(
			{
				navigatedByButton: true
			},
			() => history.replace('/cliente/compra-de-pontos')
		)
	}

	render() {
		return (
			<InnerPageContainer>
				<Title>
					<span className="bold">Ops!</span> <br /> Erro ao processar o seu
					pedido.
				</Title>
				<h3 className="gray center">
					Por favor, tente novamente dentro de alguns instantes
				</h3>
				<div style={{ display: 'flex', justifyContent: 'center' }}>
					<Button primary onClick={this.gotToBuyPoints}>
						Comprar pontos
					</Button>
				</div>
				<p className="center">
					Em caso de dúvidas, envie um e-mail para{' '}
					<a href={`mailto:${FALE_CONOSCO_EMAIL}`} className="gray">
						{FALE_CONOSCO_EMAIL}
					</a>
				</p>
			</InnerPageContainer>
		)
	}
}

const ConnectedProcessErrorPage = withRouter(connect(null)(ProcessErrorPage))

export { ConnectedProcessErrorPage as ModuleRootComponent }
